<template>
    <div class="container">
        <div class="page-content mt-10">
            <div class="row">
                <div class="col-12">
                    <h1 class="page-heading text-dark marketplace-card-header">
                        {{ $t('marketplace.title') }}
                    </h1>

                    <router-link to="/marketplace" class="btn btn-sm btn-success mb-3">
                        {{ $t('marketplace.back') }}
                    </router-link>
                </div>

                <div class="col-12 my-2" v-if="card">
                    <div class="card p-0 mb-3">
                        <div class="card-body row">
                            <div class="col-sm-4 col-5 ps-0 pe-0">
                                <a :href="CardService.getCardImageUrl(card)" data-lightbox="card">
                                    <img :src="CardService.getCardImageUrl(card)" class="card-preview" alt="">
                                </a>
                                <a :href="'/gallery/'+card.set.id">
                                    <img class="set-logo mt-4 w-100" :src="card.set.images.logo" alt=""/>
                                </a>
                            </div>
                            <div class="col-sm-8 col-7 p-0 px-4 card-data row">
                                <template v-if="card.set">
                                    <div class="mb-3 ps-0 col-12 col-md-6 col-lg-4">
                                        <h6>{{ $t('marketplace.cardInfo.set') }}</h6>
                                        <span>
                                            {{ card.set.name }} <img v-if="card.set.id !== 'base1'" class="set-icon" :src="card.set.images.symbol"/>
                                        </span>
                                    </div>

                                    <div class="mb-3 ps-0 col-12 col-md-6 col-lg-4">
                                        <h6>{{ $t('marketplace.cardInfo.series') }}</h6>
                                        <span>
                                            {{ card.set.series }}
                                        </span>
                                    </div>
                                </template>

                                <div class="mb-3 ps-0 col-12 col-md-6 col-lg-4" v-if="card.artist">
                                    <h6>{{ $t('marketplace.cardInfo.artist') }}</h6>
                                    <span>
                                        {{ card.artist }}
                                    </span>
                                </div>

                                <div class="mb-3 ps-0 col-12 col-md-6 col-lg-4" v-if="card.rarity">
                                    <h6>{{ $t('marketplace.cardInfo.rarity') }}</h6>
                                    <span>
                                        {{ card.rarity }} <img class="set-icon" :src="CardService.getRarityIconByRarity(card.rarity)"/>
                                    </span>
                                </div>

                                <div class="mb-3 ps-0 col-12 col-md-6 col-lg-4" v-if="card.types">
                                    <h6>{{ $t('marketplace.cardInfo.type') }}</h6>
                                    <span>
                                        <img v-for="type in card.types" :src="'/assets/dipocaco/type-icons/'+type+'.png'" alt="">
                                    </span>
                                </div>

                                <template v-if="(card.weaknesses && card.weaknesses.length) || (card.resistances && card.resistances.length)">
                                    <div v-if="card.weaknesses && card.weaknesses.length" class="mb-3 ps-0 col-12 col-md-6 col-lg-4">
                                        <h6>{{ $t('marketplace.cardInfo.weakness') }}</h6>
                                        <span v-for="weakness in card.weaknesses">
                                            <img loading="lazy" :src="'/assets/dipocaco/type-icons/'+weakness.type+'.png'" alt=""> {{ weakness.value }}
                                        </span>
                                    </div>

                                    <div v-if="card.resistances && card.resistances.length" class="mb-3 ps-0 col-12 col-md-6 col-lg-4">
                                        <h6>{{ $t('marketplace.cardInfo.resistance') }}</h6>
                                        <span v-for="resistance in card.resistances">
                                            <img :src="'/assets/dipocaco/type-icons/'+resistance.type+'.png'" alt=""> {{ resistance.value }}
                                        </span>
                                    </div>
                                </template>

                                <div class="mb-3 ps-0 col-12 col-md-6 col-lg-4">
                                    <h6>{{ $t('marketplace.cardInfo.id') }}</h6>
                                    <span>{{ card.id }}</span>
                                </div>

                                <div class="mb-3 ps-0 col-12 col-md-6 col-lg-4">
                                    <h6>{{ $t('marketplace.cardInfo.inCollection') }}</h6>

                                    <span v-if="card.is_in_set_collection">
                                        {{ $t('marketplace.cardInfo.yes') }} <i class="fa-solid fa-check-circle text-success"></i>
                                    </span>

                                    <span v-else>
                                        {{ $t('marketplace.cardInfo.no') }} <i class="fa-solid fa-times-circle text-danger"></i>
                                    </span>
                                </div>

                                <a v-if="card.cardmarket && card.language === 'en' && card.set.series !== 'Trading Card Game Pocket'" :href="card.cardmarket.url" class="btn w-100 text-center text-white mt-2" target="_blank" style="background-color: #012169">
                                    {{ $t('marketplace.cardInfo.showOn') }} <img src="/assets/dipocaco/cardmarket.png" style="height: 1.1em;">
                                </a>
                            </div>
                        </div>
                    </div>

                    <div>
                        <div class="col-12 px-0 my-2">
                            <a href="javascript:" class="btn btn-sm btn-success w-100" v-on:click="fetchOffersForCard(true)">
                                {{ $t('marketplace.refreshOffers') }} <i class="fa-solid fa-refresh"></i>
                            </a>
                        </div>

                        <div class="col-12 p-0" v-if="!loadingOffers">
                            <table class="table table-sm table-striped table-borderless table-hover m-0" v-if="offers.length > 0">
                                <thead class="thead-dark">
                                <tr>
                                    <th>User</th>
                                    <th class="text-end">{{ $t('marketplace.price') }}</th>
                                    <th>&nbsp;</th>
                                </tr>
                                </thead>
                                <tbody class="tbody-light">
                                <tr v-for="offer in offers">
                                    <td>
                                        <img :src="getAvatar(offer)" alt="avatar" class="avatar-image">
                                        <div class="d-inline-block ms-3 mt-1">
                                            {{ offer.user.username }}<br/>
                                            <small class="muted">{{ getCreatedAt(offer) }}</small>
                                        </div>
                                    </td>
                                    <td class="text-end" v-if="offer.price > 0">
                                        {{ offer.price }} <currency-icon/>
                                    </td>
                                    <td class="text-end" v-else>
                                        {{ $t('marketplace.free') }}
                                    </td>
                                    <td>
                                        <button class="btn btn-sm btn-danger w-100" v-on:click="purchase(offer)" v-if="offer.user_id !== $store.state.user.user_id">
                                            {{ offer.price > 0 ? $t('marketplace.buy') : $t('marketplace.get') }}
                                        </button>
                                        <button class="btn btn-sm btn-danger w-100" v-else disabled>
                                            {{ offer.price > 0 ? $t('marketplace.buy') : $t('marketplace.get') }}
                                        </button>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            <div class="alert alert-info" v-else>
                                {{ $t('marketplace.noOffersCard') }}
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="loadingOffers" class="w-100 text-center">
                    <loading-spinner/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CardService from "../../CardService";
import CurrencyIcon from "../parts/CurrencyIcon.vue";
import UserService from "../../UserService";
import moment from "moment";
import axios from "axios";
import iziToast from "izitoast";
import LoadingSpinner from "../parts/LoadingSpinner.vue";

export default {
    name: "MarketplaceCard",
    components: {LoadingSpinner, CurrencyIcon},
    data() {
        return {
            offers: [],
            card: null,
            loadingOffers: true
        };
    },
    mounted() {
        this.$store.commit('updateUserData');
        this.fetchOffersForCard();
    },
    computed: {
        CardService() {
            return CardService;
        },
    },
    methods: {
        fetchOffersForCard(manual = false) {
            this.loadingOffers = true;
            axios.get('/api/marketplace/c/' + this.$route.params.card_id).then((response) => {
                this.offers = (response.data.offers ?? [])
                this.loadingOffers = false;

                this.card = JSON.parse(response.data.card.json);
                this.card.is_in_set_collection = response.data.card.is_in_set_collection;

                if (manual) {
                    iziToast.success({title: this.$i18n.t('marketplace.notifications.refreshed'), position: 'topCenter'})
                }
            })
        },
        getAvatar(offer) {
            return UserService.getAvatarLinkByFilename(offer.user.account.avatar.filename)
        },
        getCreatedAt(offer) {
            return moment(offer.created_at).fromNow();
        },
        purchase(offer) {
            axios.post('/api/marketplace/purchase', {
                id: offer.id
            }).then(response => {
                if (response.data.success) {
                    iziToast.success({title: this.$i18n.t('marketplace.notifications.purchaseSuccsesful')});

                    this.$store.commit('updateUserCredits');
                    this.$store.commit('updateUserCards');
                    this.fetchOffersForCard();
                } else {
                    iziToast.error({title: response.data.message});
                }
            })
        },
    },
};
</script>


<style scoped lang="scss">
.card-preview {
    width: 100%;
    border-radius: 5%;
}

.form-group {
    margin-bottom: 1em;
    vertical-align: middle;

    * {
        vertical-align: middle;
    }
}

.card-set-logo {
    max-width: 100%;
    max-height: 100%;
}

.avatar-image {
    max-width: 4em;
    display: inline-block;
}

.card-name {
    font-size: 1.3em;
}

table {
    vertical-align: middle !important;
}

.card-data {
    display: flex;
    align-content: flex-start;
}

.set-icon {
    max-height: 1.5em;
}
</style>
